import { useCallback } from 'react';

import { FullZustandState } from '../types';
import { isBookwise } from '../utils/env.platform';
// eslint-disable-next-line import/no-cycle
import { globalState } from './models';

export const areBookwiseWipFeaturesEnabled = (state: FullZustandState) => {
  if (!isBookwise) {
    return true;
  }
  const profile = state.client.profile;

  if (!profile) {
    return false;
  }

  return Boolean(profile.bookwise_wip_features_enabled);
};
export const useAreBookwiseWipFeaturesEnabled = (): boolean => {
  return globalState(useCallback((state) => areBookwiseWipFeaturesEnabled(state), []));
};
